import { render, staticRenderFns } from "./MyWebsiteEdit.vue?vue&type=template&id=5ad97003&scoped=true"
import script from "./MyWebsiteEdit.vue?vue&type=script&lang=ts"
export * from "./MyWebsiteEdit.vue?vue&type=script&lang=ts"
import style0 from "./MyWebsiteEdit.vue?vue&type=style&index=0&id=5ad97003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad97003",
  null
  
)

export default component.exports